module.exports = __webpack_public_path__ + "media/images/info_icon-560718bc85fbe79fe1190a901df628b1.png";